<template>
  <v-btn text small rounded @click="setBackStep()" v-if="step > screens[0]"
    >Anterior</v-btn
  >
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: mapState("atestado", ["step", "screens"]),
  methods: mapMutations("atestado", ["setBackStep"]),
};
</script>

<style>
</style>